const answer = { block: "answer", getAttrs: (tok) => tok.attrs };

export default answer;
